import { makeStyles } from '@material-ui/styles';
import Barcode from 'react-barcode';

import '../../assets/css/print-landscape.css';

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        margin: 0,
        padding: 0,
        pageBreakAfter: 'auto'
    },
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        pageBreakInside: 'avoid',
    },
    name: {
        color: '#283851',
        paddingLeft: 20
    }
}));

const Cc3ToPrint = ({ data }) => {

    const classes = useStyles();

    return (
        <div className={classes.root}>
            <div>
                {
                    data?.map(cc3 => {
                        return (
                            <div key={cc3.idcost_center_3} className={classes.container}>
                                <Barcode value={cc3.code} width={5} />
                                <h3 className={classes.name}>{cc3.name}</h3>
                            </div>
                        );
                    })
                }
            </div>
        </div >
    );
}

export default Cc3ToPrint;